import { MaterialModule } from './material.module';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PershingCoreModule } from '@pershing/pershing-core';
import { PershingGridHeaderComponent, PershingGrid2Module } from '@pershing/pershing-grid2';
import { AgGridModule } from '@ag-grid-community/angular';
import { AgreementComponent } from './components/agreement/agreement.component';
import { ConfirmationComponent } from './components/confirmationDialog/confirmation.component';
import { DialogContainerComponent } from './components/dialogContainer/dialog-container.component';
import { EdeliveryComponent } from './components/e-delivery/e-delivery.component';
import { EdeliveryEmsComponent } from './components/e-delivery-ems/e-delivery-ems.component';
import { EdeliveryPreferenceComponent } from './components/edeliveryPreference/edelivery-preference.component';
import { AddEmailComponent } from './components/email/addEmail/addEmail.component';
import { DeleteEmailComponent } from './components/email/deleteEmail/deleteEmail.component';
import { EdeliveryEmailComponent } from './components/email/edelivery-email.component';
import { EditEmailComponent } from './components/email/editEmail/editEmail.component';
import { OneClickEnrollComponent } from './components/oneClickEnroll/one-click-enroll.component';
import { OneClickEnrollCancelComponent } from './components/oneClickEnrollCancel/one-click-enroll-cancel.component';
import { EnrollComponent } from './components/enroll/enroll.component';
import { GridDocumentsCellComponent } from './components/gridDocumentsCell/grid-documents-cell.component';
import { QuickEnrollComponent } from './components/quickEnroll/quick-enroll.component';
import { EdcEdeliveryComponent } from './edc-edelivery.component';
import { AgreementService } from './services/agreement.service';
import { EDeliveryService } from './services/edelivery.service';
import { EMailService } from './services/email.service';
import { WarningService } from './services/warning.service';
import { NoDblClickDirectiveMat } from './util/no-dbl-click-mat.directive';
import { PershingCommonModule } from '@pershing/pershing-common';


export const PERSHING_EDELIVERY_COMPONENTS: any[] = [
  EdeliveryComponent,
  EdeliveryEmsComponent,
  EdeliveryPreferenceComponent,
  EdeliveryEmailComponent,
  DialogContainerComponent,
  AgreementComponent,
  EnrollComponent,
  QuickEnrollComponent,
  OneClickEnrollComponent,
  OneClickEnrollCancelComponent,
  EditEmailComponent,
  AddEmailComponent,
  DeleteEmailComponent,
  GridDocumentsCellComponent,
  ConfirmationComponent
];

export const PERSHING_EDELIVERY_SERVICE_PROVIDERS: any[] = [
  EDeliveryService,
  EMailService,
  AgreementService,
  WarningService
];

@NgModule({
  imports: [
    PershingCoreModule,
    PershingCommonModule,
    PershingGrid2Module,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    AgGridModule.withComponents([
      PershingGridHeaderComponent,
      GridDocumentsCellComponent
    ]),    
  ],
  declarations: [
    EdcEdeliveryComponent,
    ...PERSHING_EDELIVERY_COMPONENTS,
    NoDblClickDirectiveMat
  ],
  providers: [
    ...PERSHING_EDELIVERY_SERVICE_PROVIDERS
  ],
  exports: [
    EdcEdeliveryComponent,
    ...PERSHING_EDELIVERY_COMPONENTS
  ],
  entryComponents: [
    ...PERSHING_EDELIVERY_COMPONENTS
  ]
})

export class EDCEDeliveryModule { }